import { ICreateFulfillmentParams, ICreateFulfillmentResponse } from "../../interfaces/api/oms/createFulfillment"
import ApiUtils from "../ApiUtils"
import { IOmsService } from "./IOmsService"

const OmsUrls = {
	getAddress: (userId: string) => `/address/user/${userId}`,
	getAddressById: (addressId: string) => `/address/${addressId}`,
	createFulfillment: (apiKey: string) => `/fulfillment/createFulfillment?apiKey=${apiKey}`,
}
class OmsServiceApis implements IOmsService {
	getServiceUrl = (url: string) => "/oms" + url
	getUserAddresses(userId: string) {
		const url = this.getServiceUrl(OmsUrls.getAddress(userId))
		return ApiUtils.get(url)
	}

	getUserAddressById(addressId: string): Promise<any> {
		const url = this.getServiceUrl(OmsUrls.getAddressById(addressId))
		return ApiUtils.get(url)
	}
	createFullfillment = (params: ICreateFulfillmentParams, headers?: any): Promise<ICreateFulfillmentResponse> => {
		const { apiKey, userId, ...restParams } = params
		const url = this.getServiceUrl(OmsUrls.createFulfillment(apiKey))
		return ApiUtils.post(url, restParams, headers)
	}
}

export default OmsServiceApis
